/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//  $('.HorizontalList__Item label').click(function(){
//     setTimeout(function() {
//  var p_id = $('[name="id"]').val();
//  var price = $('[name="id"] option[value="'+p_id+'"]').attr('data-price');
//  $('.ProductMeta__PriceList').html('<span class="ProductMeta__Price Price Text--subdued u-h4 tw-text-30px tw-font-semibold ">'+ price +'</span>');
//     },50);
//  });



   //  $('.ad_to_cart_coll').click(function(){
   //   console.log("clicked");
   //   var ID = $(this).attr("data-var_id");
   //   addItemToCart( ID, 1);    // paste your id product number
   // });

 

document.addEventListener("DOMContentLoaded", async () => {

   


        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        // @ts-ignore
        let value = params.gclid;
        if (value !== "" && value !== null) {
            const raw = JSON.stringify({
                "gclid": value,
                "name": "balmarkde",
            });
            let ssdi = await post("https://conversion.trise.one/api/conversion/create", raw);
            sessionStorage.setItem("swt-ct", ssdi.uuid);
        }



        const submitButtons = document.querySelectorAll(".Cart__Checkout, .Cart__Checkout span");
        const cartHeaderBtn = document.querySelector(".Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable[aria-label='Warenkorb öffnen']");

        if (cartHeaderBtn) {
            cartHeaderBtn.addEventListener("click", async () => {
                console.log("submitted")
                    let swtct = sessionStorage.getItem("swt-ct");
                    let sumElement = document.querySelector(".Cart__Checkout span:last-of-type");

                    if (sumElement) {
                        const strSum = sumElement.innerHTML.slice(0, -2);
                        let sum = parseFloat(strSum.replace(',', '.'));

                        if (swtct) {
                            const raw = JSON.stringify({
                                "uuid": swtct,
                                "conversion_time": null,
                                "conversion_value": sum,
                                "conversion_currency": "EUR"
                            });


                            await post("https://conversion.trise.one/api/conversion/update", raw);

                        }
                    }
                
            });
        }
        
        if (submitButtons) {
            for (let submitButton of submitButtons) {
                
                submitButton.addEventListener("mouseover", async () => {
                    console.log("submitted")
                    let swtct = sessionStorage.getItem("swt-ct");
                    let sumElement = document.querySelector(".Cart__Checkout span:last-of-type");

                    if (sumElement) {
                        const strSum = sumElement.innerHTML.slice(0, -2);
                        let sum = parseFloat(strSum.replace(',', '.'));

                        if (swtct) {
                            const raw = JSON.stringify({
                                "uuid": swtct,
                                "conversion_time": null,
                                "conversion_value": sum,
                                "conversion_currency": "EUR"
                            });


                            await post("https://conversion.trise.one/api/conversion/update", raw);

                        }
                    }
                })
            }

        }
    

});


async function post(url, data) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Basic c2VvbmljYWxzOmxVWkhhaGp1QDl1aTE=");

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: data,
        mode: "cors",
        redirect: "follow"
    };

    const response = await fetch(url, requestOptions)
    return await response.json();
}
